import React, { useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import CardItem from '../CardItem';

function Listings() {

    const [listings, setListings] = useState();
    const params = useParams();



    useEffect(() => {
        if(!listings){
            try{
                fetch("/api/county/" + params.county)
                .then((result) => result.json()).then((data) =>{
                    for(let i = 0; i < data.length; i++){
                        if(data[i].PropertyType === "Land"){
                           setListings({houseListings:(data.slice(0, i)),
                           landListings:data.slice(i, data.length)}); 
                           break;
                        }
                    }
                })
            }
            catch(err){
                console.log(err)
            }
        }
    }, [])

    
    return (
        <div className='featured'>
            <div className='header_search'>
                <h1>{params.county} county</h1>
            </div>
            {listings && listings.houseListings.length !== 0 &&
            <>
            <h1>Home listings</h1>
            <div className='featuredHomes'>
                {listings.houseListings.map((listing, i) => {
                    return <CardItem key={i} src={listing.Media[0].LocalMediaURL} address={listing.UnparsedAddress} price={listing.ListPrice} bed={listing.BedroomsTotal} bath={listing.BathroomsTotalInteger} sqft={listing.LotSizeSquareFeet} listingKey={listing.ListingKey} PropertyType={listing.PropertyType} county={listing.CountyOrParish}/>
                })}
            </div>
            </>
            }
            {listings && listings.landListings.length !== 0 &&
            <>
            <h1>Land Listings</h1>
            <div className='featuredHomes'>
                {listings && listings.landListings.map((listing, i) => {
                    return <CardItem key={i} src={listing.Media[0].LocalMediaURL} address={listing.UnparsedAddress} price={listing.ListPrice} sqft={listing.LotSizeSquareFeet} listingKey={listing.ListingKey} PropertyType={listing.PropertyType} county={listing.CountyOrParish}/>
                })}
            </div>
            </>
            }
        </div>
    );
    }

export default Listings;
